import React, { useEffect, useState, useCallback } from "react";
import { Plane, X, MapPin, Image as ImageIcon, Check } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

// Popup approval absen "Luar Kota / BC" dari absensi.deteksipipabocor.com.
// Satu keputusan (approve/tolak) berlaku untuk semua admin; "Nanti" hanya menyembunyikan di sesi ini.
const photoHref = (u) => (!u ? "" : u.startsWith("/") ? `https://absensi.deteksipipabocor.com${u}` : u);

const AttendanceApprovalPopup = () => {
  const [items, setItems] = useState([]);
  const [snoozed, setSnoozed] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get("/attendance-approvals/pending").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const iv = setInterval(load, 20000);
    return () => clearInterval(iv);
  }, [load]);

  const decide = async (a, action) => {
    setBusy(true);
    try {
      await api.post(`/attendance-approvals/${a.id}`, { action });
      setItems((prev) => prev.filter((x) => x.id !== a.id));
      toast.success(action === "approve" ? `Absen luar kota ${a.technician_name} disetujui` : `Absen luar kota ${a.technician_name} ditolak`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal menyimpan keputusan");
    } finally {
      setBusy(false);
    }
  };

  const visible = items.filter((x) => !snoozed.includes(x.id));
  if (!visible.length) return null;
  const a = visible[0];
  const color = "#7C3AED";

  return (
    <div className="fixed inset-0 z-[61] bg-black/40 flex items-center justify-center p-4" data-testid="attendance-approval-popup">
      <div className="bg-white w-full max-w-md border-2 shadow-2xl" style={{ borderColor: color }}>
        <div className="flex items-center justify-between px-4 py-3 text-white" style={{ backgroundColor: color }}>
          <div className="flex items-center gap-2 font-heading font-bold">
            <Plane size={20} /> Approval Absen Luar Kota / BC
          </div>
          <button onClick={() => setSnoozed((p) => [...p, a.id])} className="p-1 hover:bg-white/20" aria-label="Tutup"><X size={18} /></button>
        </div>
        <div className="p-4 space-y-2 text-sm">
          <p>
            <span className="font-bold">{a.technician_name}</span> absen masuk dari lokasi{" "}
            <span className="font-bold" style={{ color }}>Luar Kota / BC</span> pada{" "}
            <span className="font-mono font-bold">{a.jam_masuk}</span>.
          </p>
          <div className="flex flex-wrap gap-3 text-xs">
            {a.lat != null && a.lng != null && (
              <a href={`https://www.google.com/maps?q=${a.lat},${a.lng}`} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-1 text-[#002FA7] font-bold hover:underline">
                <MapPin size={13} /> {Number(a.lat).toFixed(5)}, {Number(a.lng).toFixed(5)}
              </a>
            )}
            {a.photo_url && (
              <a href={photoHref(a.photo_url)} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-1 text-[#002FA7] font-bold hover:underline">
                <ImageIcon size={13} /> Lihat selfie
              </a>
            )}
          </div>
          <p className="text-xs text-[#52525B]">Jika disetujui, status di dashboard menjadi "Luar Kota/BC" dan di payroll tercatat luar kota. Jam masuk tetap tercatat.</p>
          {visible.length > 1 && <p className="text-xs text-[#52525B]">+{visible.length - 1} absen lain menunggu</p>}
        </div>
        <div className="flex gap-2 px-4 pb-4">
          <button disabled={busy} onClick={() => decide(a, "approve")} data-testid="attendance-approve"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#059669] text-white px-3 py-2 text-xs font-bold uppercase tracking-wider hover:bg-[#059669]/90 disabled:opacity-60">
            <Check size={14} /> Approve
          </button>
          <button disabled={busy} onClick={() => decide(a, "reject")} data-testid="attendance-reject"
            className="px-3 py-2 text-xs font-bold uppercase tracking-wider border border-[#DC2626] text-[#DC2626] hover:bg-[#DC2626]/5 disabled:opacity-60">
            Tolak
          </button>
          <button onClick={() => setSnoozed((p) => [...p, a.id])}
            className="px-3 py-2 text-xs font-bold uppercase tracking-wider border border-[#E4E4E7] hover:bg-[#F4F4F5]">
            Nanti
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttendanceApprovalPopup;
